import { runtimeConfig } from '@/config/runtime-config';
import { ROUTES } from '@/consts/routes';

const BASE_URL = import.meta.env.VITE_BASE_URL;
export const clerkConfig = {
  publishableKey: runtimeConfig.clerkPublishableKey,
  signInUrl: `${BASE_URL}${ROUTES.auth.login}`,
  signUpUrl: `${BASE_URL}${ROUTES.auth.acceptInvitation}`,
  signInFallbackRedirectUrl: BASE_URL,
  signUpFallbackRedirectUrl: BASE_URL
} as const;
